import { createApp,defineAsyncComponent } from 'vue'
import router from './router/router'
import axios from 'axios'
import json from '../public/Config.json'
import Swal from 'sweetalert2'
import App from './App.vue'
import session from './session' 
import elementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import moment from 'moment'
import {createBootstrap} from 'bootstrap-vue-next'
import { useMainStore } from './Store/index'
import { createPinia } from "pinia";
import piniaPluginPersistedState from "pinia-plugin-persistedstate"
import VueApexCharts from "vue3-apexcharts";
import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const pinia = createPinia();
const app = createApp(App)
app.use(createBootstrap())

app.component('datePicker', defineAsyncComponent(() => import('./components/DatePicker.vue')));
app.component('uploadImage', require('./components/UploadImage.vue').default);
app.component('addMedicalRecords', require('./components/MedicalRecords/AddMedicalRecords.vue').default);
app.component('modalComponent',defineAsyncComponent(() => import('./components/ModelComponent.vue')));
app.component('attachment-list', require('./components/Attachment/AttachmentList.vue').default);
app.component('add-attachment-model', require('./components/Attachment/AddAttachmentModel.vue').default);
app.component('bulk-attachment', require('./components/Attachment/importAttachment.vue').default);
app.component('attachment-view', require('./components/Attachment/attachmentView.vue').default);
app.component('departmentsDropdown', require('./components/Dropdowns/departmentsDropdown.vue').default);
app.component('servicesDropdown', require('./components/Dropdowns/servicesDropdown.vue').default);
app.component('familyDropdown', require('./components/Dropdowns/familyDropdown.vue').default);

app.component('patientDropdown', require('./components/Dropdowns/patientDropdown.vue').default);
app.component('reportsDropdown', require('./components/Dropdowns/reportsDropdown.vue').default);


app.component('specializationDorpdowm', require('./components/Dropdowns/specializationDorpdowm.vue').default);
app.component('doctorAddSlotsModel', require('./components/DoctorProfile/doctorAddSlotsModel.vue').default);
app.component('addDeparmtentModel', require('./components/Departments/AddDepartment.vue').default);
app.component('addReportsModel', require('./components/Reports/addReports').default);
app.component('genderDropdown', require('./components/Dropdowns/genderDropdown').default);
app.component('priceDropdown', require('./components/Dropdowns/priceDropdown').default);


app.use(VueApexCharts);
app.component('apexChart', VueApexCharts);

pinia.use(piniaPluginPersistedState)
app.use(pinia);
app.use(moment);
app.use(elementPlus);
// Set global properties for axios and ServerIP
app.config.globalProperties.$https = axios
app.config.globalProperties.$swal = Swal
axios.defaults.baseURL = json.ServerIP
app.config.globalProperties.$ServerIp = json.ServerIP
app.config.globalProperties.$swiper = Swiper;
app.config.globalProperties.$store = useMainStore();

app.use(session)
// Use router and mount the app
app.use(router)

app.mount('#app')
